import React, { useState, useEffect } from "react";
import amaxLogo from "../../images/amaxLogoWhite.png";
import arrowNext from "../../images/arrowNext.svg";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AthleteStep4 = () => {
  const navigate = useNavigate();

  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [dob, setDob] = useState(null); // store Date object
  const [gender, setGender] = useState("");
  const [error, setError] = useState(null);

  // --- Utility functions ---
  const formatDateForStorage = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const parseStoredDate = (dateStr) => {
    if (!dateStr) return null;
    const [month, day, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  // --- Load saved session data ---
  useEffect(() => {
    const city_ = sessionStorage.getItem("city");
    const state_ = sessionStorage.getItem("state");
    const dob_ = sessionStorage.getItem("dob");
    const gender_ = sessionStorage.getItem("gender");

    if (city_) setCity(city_);
    if (state_) setState(state_);
    if (dob_) setDob(parseStoredDate(dob_));
    if (gender_) setGender(gender_);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!city || !state || !gender || !dob) {
      setError("Please enter all the details!");
      return;
    }

    setError(null);

    sessionStorage.setItem("city", city);
    sessionStorage.setItem("state", state);
    sessionStorage.setItem("gender", gender);
    sessionStorage.setItem("dob", formatDateForStorage(dob)); // store in MM-DD-YYYY

    navigate("/athlete/register/step5");
  };

  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-28 overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>

        <div className="flex flex-col gap-12 w-full">
          <div>
            <div className="flex flex-col justify-center gap-4 xs:gap-10">
              <div className="flex flex-col gap-4">
                <h1 className="text-black text-3xl xs:text-4xl leading-tight font-light uppercase">
                  ATHLETE
                  <br />
                  <span className="text-4xl xs:text-5xl leading-tight font-bold">PROFILE</span>
                </h1>

                <div>
                  <input
                    type="text"
                    className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase w-full mb-[15px]"
                    placeholder="City*"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                  <input
                    type="text"
                    className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase w-full"
                    placeholder="State*"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                {/* DOB Picker */}
                <div className="flex-1 min-w-[160px] relative border border-grayish rounded-[15px] px-5 py-4 flex flex-col justify-between cursor-pointer overflow-visible">
                  <p className="text-black text-lg mb-1">DOB</p>
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="relative z-50"
                  >
                    <DatePicker
                      selected={dob}
                      onChange={(date) => setDob(date)}
                      dateFormat="MM-dd-yyyy"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      className="bg-transparent text-black text-[20px] w-full focus:outline-none cursor-pointer truncate"
                      placeholderText="MM-DD-YYYY"
                      popperPlacement="bottom-start"
                      popperClassName="z-50"
                      withPortal // ✅ crucial for iPhone (renders picker in portal)
                    />
                  </div>
                </div>

                {/* Gender Selection */}
                <form className="flex flex-col gap-[10px] w-[149px]">
                  <p className="text-black text-lg ml-2">Gender</p>
                  <div className="flex gap-2 w-full justify-between">
                    <label className="flex items-center flex-col cursor-pointer">
                      <input
                        type="radio"
                        name="gender"
                        value="Male"
                        checked={gender === "Male"}
                        onChange={() => setGender("Male")}
                        className="hidden"
                      />
                      <span
                        className={`w-[50px] h-[50px] rounded-full ${
                          gender === "Male" ? "bg-black" : "bg-black/20"
                        }`}
                      ></span>
                      <span className="text-black mt-[10px] text-sm">
                        Male
                      </span>
                    </label>
                    <label className="flex items-center flex-col cursor-pointer">
                      <input
                        type="radio"
                        name="gender"
                        value="Female"
                        checked={gender === "Female"}
                        onChange={() => setGender("Female")}
                        className="hidden"
                      />
                      <span
                        className={`w-[50px] h-[50px] rounded-full ${
                          gender === "Female" ? "bg-black" : "bg-black/20"
                        }`}
                      ></span>
                      <span className="text-black mt-[10px] text-sm">
                        Female
                      </span>
                    </label>
                  </div>
                </form>
              </div>
            </div>

            {error && <p className="text-red-500 text-sm mt-5">{error}</p>}
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="bg-black size-12 xs:size-14 rounded-full flex justify-center items-center hover:bg-black/70 transition-all duration-300 ml-auto"
          >
            <img
              src={arrowNext}
              alt="arrow"
              className="object-contain invert max-w-5 xs:max-w-6 "
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AthleteStep4;
